define('modules/product-card-addtocart',[
  'jquery',

  'connections/cart-connection',
  'connections/product-connection',

  'models/user',

  'modules/options-menu',
  'modules/overlay-box',

  'views/quick-cart',

  'utils/string-interpolate',
  'utils/price-format',

  'settings'
], function ($, CartConnection, ProductConnection, user, OptionsMenu, OverlayBox, QuickCart, s, priceFormat, settings) {
  var ProductCardAddToCart = (function () {
    /**
     * @class ProductCardAddToCart
     * @constructor
     */
    function ProductCardAddToCart() {
      this.matrices = {};
    }

    /**
     * Init binding events that open the view
     *
     * @method init
     */
    ProductCardAddToCart.prototype.init = function (outlet) {
      this.isOutlet = outlet;
      var _this = this;

      // prevent opening quick view if user is not logged in.
      if (!user.isLoggedin()) {
        return false;
      }

      $('body').on('click', '.button--quickview', this.show.bind(this));
      $('body').on('click', '.quickview__close', this.hide.bind(this));
      $('body').on('click', '.quickview__addtocart', this.addToCart.bind(this));
      $('body').on('click', '.quickview__select', OptionsMenu.toggle);
      OptionsMenu.addBodyCloseListener('.quickview__select');
      $('body').on('focus', '.quickview__sku-input--qty', function () {
        $(this).select();
      });
      $('body').on('input', '.quickview__sku-input--qty', function () {
        _this.toggleAddButton(_this.getProductMatrixFromEl($(this)));
      });
    };

    ProductCardAddToCart.prototype.toggleAddButton = function (matrix) {
      var qty = matrix.el.find('.quickview__sku-input--qty').val();
      var rounded = Math.round(qty);

      if (rounded != qty) matrix.el.find('.quickview__sku-input--qty').val(rounded);
      if (!rounded || !matrix || !matrix.selectedConfig) {
        matrix.el.find('.quickview__addtocart').attr('disabled', 'disabled');
      } else {
        matrix.el.find('.quickview__addtocart').removeAttr('disabled');
      }
    };

    /**
     * Get product data
     *
     * @method getProduct
     * @param  {String} productId
     * @return {Object}
     */
    ProductCardAddToCart.prototype.getProduct = function (productId, $card) {
      var _this = this;
      var $loader = $card.find('.quickview__loader');

      $loader.show();
      // get product data from API. (available sizes and colors)
      ProductConnection.getProductMatrixData(productId, false, this.isOutlet).then(function (res) {
        res.el = $card;
        _this.matrices[productId] = res;
        _this.populateColors(productId);

        $loader.fadeOut('fast');
      });
    };

    /**
     * Populate the dropdown list with available colors.
     * @param  {[type]} productId [description]
     * @return {[type]}           [description]
     */
    ProductCardAddToCart.prototype.populateColors = function (productId) {
      var matrix = this.matrices[productId];
      if (!matrix) return;

      var _this = this;
      var $card = matrix.el;
      var $colorList = $card.find('.quickview__sku-input--color ul');
      $.each(matrix.rows, function (i, color) {
        if (!color.quantities.length) return;
        var colorName = color.nameNoCode ? color.nameNoCode : s('(%s)', [color.code]);
        var $li = $(s('<li data-code="%s">%s</li>', [color.code, colorName]));
        $colorList.append($li);
      });

      $card.find('.originalColorLabel').removeClass('disabled');
      $colorList.on('click', 'li', function (e) {
        var colorCode = $(this).data('code').toString();
        var $icon = $colorList.prev('span').find('i').detach();
        $colorList.prev('span').text($(this).text()).append($icon);

        matrix.selectedConfig = null;
        _this.toggleAddButton(matrix);

        _this.populateSizes(productId, colorCode);
        _this.changeProductImage(productId, colorCode);
        _this.emptyPriceAndStock($card);
      });

      // Always pre-select first color
      $colorList.click();
      $colorList.find('li').first().click();
    };

    ProductCardAddToCart.prototype.changeProductImage = function (productId, colorCode) {
      if (colorCode == 'lonelyItem') return;

      var matrix = this.matrices[productId];
      var _this = this;

      if (!matrix.productImages) {
        ProductConnection.getProductImages(productId).then(function (res) {
          matrix.productImages = res;
          _this.setImage(matrix, colorCode);
        });
      } else {
        this.setImage(matrix, colorCode);
      }
    };

    ProductCardAddToCart.prototype.setImage = function (matrix, colorCode) {
      if (!matrix.productImages.color || !matrix.productImages.color.length) return;

      var color = matrix.productImages.color.filter(function (color) {
        return color.colorCode === colorCode;
      });

      if (!color.length || !color[0].images.length) return;

      matrix.el.find('.product__image img').attr('src', color[0].images[0].src);
    };

    ProductCardAddToCart.prototype.populateSizes = function (productId, colorCode) {
      if (!this.matrices[productId]) return;

      // Get selected color from matrix
      var matrix = this.matrices[productId];
      var row = matrix.rows.filter(function (row) {
        return row.code === colorCode;
      });

      if (!row.length) return;

      // Get all labels in and hash by their value.
      var sizeLabels = matrix.columns.reduce(function (obj, col, i) {
        obj[col.value] = col.label;
        return obj;
      }, {});
      matrix.sizeLabels = sizeLabels;

      var _this = this;
      var $card = matrix.el;

      $card.find('.sizeLabel').remove();
      var $originalSizeLabel = $card.find('.originalSizeLabel');
      $originalSizeLabel.show().removeClass('disabled');

      var $sizeList = $card.find('.quickview__sku-input--size ul').empty();
      $.each(row[0].quantities, function (i, sku) {
        var $li = $(s('<li data-sku="%s">%s</li>', [sku.sku, sizeLabels[sku.value]]));
        $sizeList.append($li);
      });

      $sizeList.off('click').on('click', 'li', function (e) {
        var $icon = $originalSizeLabel.hide().find('i').clone();
        $card.find('.sizeLabel').remove();
        var $sizeLabel = $('<span>' + $(this).text() + '</span>')
          .addClass('sizeLabel')
          .append($icon);
        $sizeList.parent().prepend($sizeLabel);

        var sku = $(this).data('sku').toString();
        var selectedConfig = row[0].quantities.filter(function (config) {
          return config.sku === sku;
        });
        if (selectedConfig.length) matrix.selectedConfig = selectedConfig[0];

        _this.emptyPriceAndStock($card);
        _this.getPriceAndStock($card, sku, matrix.selectedConfig);
        _this.toggleAddButton(matrix);

        $card.find('.quickview__sku-input--qty').focus();
      });

      // lonely items - preselect first item.
      if (colorCode === 'lonelyItem') {
        $sizeList.click();
        $sizeList.find('li').first().click();
      }
    };

    ProductCardAddToCart.prototype.emptyPriceAndStock = function ($card) {
      $card.find('.quickview__pricestock').hide().find('quickview__stock').add($card.find('.quickview__price')).empty();
    };

    ProductCardAddToCart.prototype.getPriceAndStock = function ($card, sku, config) {
      var $priceStockContainer = $card.find('.quickview__pricestock');
      var $lonelyItemInput = $card.find('.quickview--lonelyitem .quickview__sku-input--qty');
      var $packinformation = $card.find('.quickview--lonelyitem .quickview__packinformation');
      var inboxItems = config && config.inboxItems ? config.inboxItems : 1;

      $packinformation.hide();

      if (inboxItems > 1) {
        var packages = $packinformation.data("packagesText");
        var pieces = $packinformation.data("piecesText");
        $packinformation.find('.quickview__packinformation__left').text(packages);
        $packinformation.find('.quickview__packinformation__right').text(inboxItems + ' ' + pieces);
        $packinformation.show();
      }

      var stockText = config && config.stock ? config.stock : '-';
      $priceStockContainer.find('.quickview__stock').text(stockText);

      indicateStockStatus($priceStockContainer.find('.quickview__stockmark'), config);

      $priceStockContainer.fadeIn('fast');

      ProductConnection.getCustomerPriceView(sku, inboxItems).then(function (html) {
        $priceStockContainer.find('.quickview__price').html(html);
        $priceStockContainer.fadeIn('fast');
      });
    };

    /**
     * Show product add to cart view
     *
     * @method show
     * @param  {String} productId
     */
    ProductCardAddToCart.prototype.show = function (e) {
      var $productCard = $(e.target).closest('article.product');
      var productId = $productCard.data('product-id');

      var $quickView = $productCard.find('.quickview');

      $quickView.fadeIn('fast');
      if (!this.matrices[productId]) this.getProduct(productId, $productCard);
    };

    ProductCardAddToCart.prototype.getProductMatrixFromEl = function ($el) {
      var $productCard = $el.closest('article.product');
      var productId = $productCard.data('product-id');

      return this.matrices[productId];
    };

    ProductCardAddToCart.prototype.resetMatrices = function () {
      this.matrices = {};
    };

    /**
     * Hide quickview for specific product.
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    ProductCardAddToCart.prototype.hide = function (e) {
      $(e.target).closest('.quickview').fadeOut('fast');
    };

    /**
     * Add sku to cart and update total quantity.
     * @param {String} sku  - the sku to add to cart
     * @param {Number} qty  - number of items to add.
     * @param {string} size - a description of size to make it faster to display it in the cart.
     */
    ProductCardAddToCart.prototype.addToCart = function (e) {
      $(e.target).prop('disabled', true);

      var matrix = this.getProductMatrixFromEl($(e.target));
      if (!matrix || !matrix.selectedConfig) return;
      
      var $qty = matrix.el.find('.quickview__sku-input--qty');
      var qty = $qty.val();
      var sku = matrix.selectedConfig.sku;
      var size = matrix.sizeLabels[matrix.selectedConfig.value];
      var stock = matrix.selectedConfig.stock;
      var boxItems = matrix.selectedConfig.inboxItems;
      
      if (boxItems && boxItems > 1) qty = qty * boxItems;
      if (!sku || !qty) return;
      
      var item = {
        sku: sku,
        quantity: qty,
        size: size
      };

      if (stock - qty < 0 && settings.exceedAvailableStockWarningEnabled) {
        var ob = new OverlayBox(settings.templates.stockQtyWarning, {});
        ob.setup();
        ob.load(function () {
          ob.show();
          $('[confirm-stock-qty-warning]').one('click', function () {
            CartConnection.add([item]).then(function (res) {
              QuickCart.printTotalQuantity(res);
              $(e.target).prop('disabled', false);
            });

            ob.destroy();
          });
          $('[cancel-stock-qty-warning]').one('click', function () {
            ob.destroy();
          });
        });
      } else {
        CartConnection.add([item]).then(function (res) {
          QuickCart.printTotalQuantity(res);
          $(e.target).prop('disabled', false);
        });
      }
    };

    return ProductCardAddToCart;
  })();

  function indicateStockStatus($stockMark, config) {
    var stockClass = 'order-matrix__piece-count-in-stock__in-stock';

    if (!config || config.stock <= 0) {
      stockClass = 'order-matrix__piece-count-in-stock__out-of-stock';
    }
    var stockToken = config && config.stock > 0 ? '&#10003;' : '&#10007;';
    var indicator = '<span class="' + stockClass + '">' + stockToken + '</span> - ' + config.stockIndicator;
    $stockMark.html(indicator);
  }

  return new ProductCardAddToCart();
});

